import React, { useState } from 'react'
import { useIncrementalPrompting } from '../../services/incrementalPromptingService';
import { useDispatch, useSelector } from 'react-redux';
import spinner from '../../assets/images/spinner.png'
import { useLocation, useNavigate } from 'react-router-dom';
import { setIsVisualizePageVisible, updateGeneratedImagesFromPastCreation } from '../../redux/createImageSlice';
import { setPrompt } from '../../redux/promptSlice';
import { setFontLoading, setRecommendedFontList } from '../../redux/fontListSlice';

const SelectFont = ({ onClose, imageInputValue, imageData, fontInputValue }) => {
    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const incrementalPrompting = useIncrementalPrompting()

    const { EditFontList, isEditFontLoading } = useSelector(state => state.fontList)
    const { pastCreationData } = useSelector(state => state.pastCreation)
    const { generatedImages } = useSelector(state => state.createImage)

    const [selectedFont, setSelectedFont] = useState('')

    const handleFontSelection = (fontName) => {
        setSelectedFont(fontName);
    }

    const handleApplyFont = () => {

        // let itPrompt = "<IT>" + imageInputValue + " and " + fontInputValue
        // let itPrompt =imageInputValue + " and " + fontInputValue


        if (location.pathname === '/your-past-creations') {
            dispatch(setIsVisualizePageVisible(false));
            navigate('/generate-image');

            const matchingPastCreation = pastCreationData.find((item) => item.promptId === imageData.promptId);
            const matchingGeneratedImage = generatedImages[0]?.promptId === imageData?.promptId;

            if (!matchingGeneratedImage) {
                dispatch(setFontLoading(true));
                dispatch(setRecommendedFontList(EditFontList))
                dispatch(setPrompt(imageData.prompt));
                dispatch(updateGeneratedImagesFromPastCreation({
                    images: matchingPastCreation.images,
                }))
            }
        }
        incrementalPrompting(imageInputValue, imageData, selectedFont, fontInputValue)
    }

    return (
        <div className='h-[448px] w-[542px] bg-white rounded-[16px] pr-1'>
            <div className='h-full flex flex-col'>
                <div className='w-full h-[96px] border-b flex items-center'>
                    <h1 className='px-[40px] text-[28px] font-helveticaText-Medium font-[500] leading-[32px] text-cus_primary'>
                        Select a font to apply on image
                    </h1>
                </div>
                <div className='h-[240px] w-full pl-[40px] flex flex-col border-b overflow-y-scroll'>
                    {isEditFontLoading ? <div className='h-full pr-[40px] flex items-center justify-center'>
                        <img src={spinner} alt="loading" className='animate-spin' />
                    </div> :
                        EditFontList.map((font, index) => (
                            <div
                                key={index}
                                className={`py-[24px] flex items-center gap-[16px] border-b cursor-pointer `}
                                onClick={() => handleFontSelection(font)}
                            >
                                <input
                                    type="radio"
                                    checked={selectedFont === font}
                                    onChange={() => handleFontSelection(font)}
                                    className="custom-radio"
                                />
                                <label>{font.font_name}</label>
                            </div>
                        ))}
                </div>

                <div className='h-[112px] px-[40px] flex items-center gap-[16px] '>
                    <button onClick={onClose} className='h-[48px] px-[16px] py-[8px] bg-gray-light text-cus_primary rounded-[8px] flexCenter gap-[8px]'>
                        Cancel
                    </button>
                    <button onClick={handleApplyFont} className='h-[48px] px-[16px] py-[8px] bg-pink-primary text-white rounded-[8px] flexCenter gap-[8px]'>
                        Apply
                    </button>
                </div>
            </div>
        </div >
    )
}

export default SelectFont